import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useModalEffect from '../../../hooks/useModalEffect';

const ViewTypeUnit = ({ isOpen, onClose, data }) => {
  useModalEffect(isOpen);
  ;

  // Cleanup effect when component unmounts
  useEffect(() => {
    return () => {
      // Clean up any remaining modal states when component unmounts
      const cleanupModal = () => {
        // Remove modal scroll lock
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('modal-backdrop');
      };
      
      cleanupModal();
    };
  }, []);


  // Cleanup effect: reset modal body state when component unmounts.
  useEffect(() => {
    return () => {
      // React owns the backdrop DOM (createPortal); only reset body state here.
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
    };
  }, []);

  if (!data) return null;

  return (
    <>
      <div
        className={`modal modal-blur fade${isOpen ? ' show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }}
        id="modal-view-type-unit"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Type Unit Details</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row mb-3">
                <div className="col-4 fw-bold">Type Unit Name</div>
                <div className="col-8">{data.typeUnitName}</div>
              </div>
              <div className="row mb-3">
                <div className="col-4 fw-bold">Description</div>
                <div className="col-8">{data.description}</div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ViewTypeUnit.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default ViewTypeUnit; 